import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-carousel',
  templateUrl: './student-carousel.component.html',
  styleUrls: ['./student-carousel.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class StudentCarouselComponent implements OnInit {

  @Input('membersList') membersList:any[]=[];
  
  connectnow() {
    window.open('https://www.iquanta.in/blog/category/cat-non-cat/cat-exam/success-stories/', '_blank')
  }

  constructor() { }

  videoCarouselFlag: boolean = false;
  ngAfterViewChecked() {
  }

  ngOnInit() {

  }

  slickInit(e: any) {
  }

  breakpoint(e: any) {
  }

  afterChange(e: any) {
  }

  beforeChange(e: any) {
  }

  blog() {
    window.open('https://www.iquanta.in/blog/category/success-stories/', '_blank')
  }
}
